import { Divider, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ReactComponent as MediaIcon } from 'assets/icons/edit-image.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit-white.svg';
import { DrawerMedia, GridWrap, InfoWrapper, Table } from 'components';
import { FieldType, MediaGroup, UploadMedia } from 'constants/inspections';
import { tipologiaTraversoOptions } from 'constants/selectOptions';
import { useInspectionPath } from 'hooks';
import { INFO } from 'pages/Inspections/config/info';
import { useInspectionSelector } from 'stores';
import TraversiForm from './TraversiForm';

const TraversiSection = ({ selectedIdx }) => {
  const { watch, setValue, getValues } = useFormContext();
  const { inspectionDisabled } = useInspectionSelector();
  const { isViewingInspection } = useInspectionPath();

  const mensoleTamponiCampateImpalcatoTableTraversiTableWatch = watch(
    `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traversiTable`
  );

  // table setup
  const dataConfigTraversi = {
    columns: {
      codice: { label: 'Codice' },
      tipologiaTraverso: {
        label: 'Tipologia',
        format: tipologiaTraversoOptions,
      },
      altezzaTraverso: {
        label: 'H [cm]',
      },
      lunghezzaTraverso: {
        label: 'L [cm]',
      },
      spessoreTraverso: {
        label: 's [cm]',
      },
      superficieTraverso: {
        label: 'Sup. [m²]',
        formatValue: val => `${(+val)?.toFixed(2)}`,
      },
    },
  };

  // traversi setup
  const [selectedTraversi, setSelectedTraversi] = useState([]);
  const [open, setOpen] = useState(false);
  const [drawerMediaIndex, setDrawerMediaIndex] = useState();

  const editRowsTraversi = item => {
    setValue('l0t2a5_traversiTableValue', [item]);
    setValue('l0t2a5_tipologiaTraversoTableValue', item.tipologiaTraverso);
    setValue('l0t2a5_altezzaTraversoTableValue', item.altezzaTraverso);
    setValue('l0t2a5_lunghezzaTraversoTableValue', item.lunghezzaTraverso);
    setValue('l0t2a5_spessoreTraversoTableValue', item.spessoreTraverso);
    setValue('l0t2a5_superficieTraversoTableValue', item.superficieTraverso);
  };
  const handleSelectAllClickTraversi = event => {
    if (event.target.checked) {
      const selectedValue = getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traversiTable`
      );
      setSelectedTraversi(selectedValue);
      setValue('l0t2a5_traversiTableValue', selectedValue);
    } else {
      setSelectedTraversi([]);
      setValue('l0t2a5_traversiTableValue', []);
    }
  };

  return (
    <>
      <GridWrap container spacing={2} style={{ marginTop: 16 }}>
        <InfoWrapper
          isDivider={true}
          size={12}
          infoDrawer={true}
          drawerTitle={INFO.impalcatoTraversi.drawerTitle}
          drawerText={INFO.impalcatoTraversi.drawerText}
        >
          <Divider>TRAVERSI</Divider>
        </InfoWrapper>
        {mensoleTamponiCampateImpalcatoTableTraversiTableWatch?.length ===
          0 && (
          <GridWrap item xs={12} paddingTop={'0px !important'}>
            <Typography>Nessun traverso presente in questo elemento</Typography>
          </GridWrap>
        )}
      </GridWrap>
      {mensoleTamponiCampateImpalcatoTableTraversiTableWatch?.length > 0 && (
        <>
          {!inspectionDisabled && !isViewingInspection && (
            <TraversiForm
              traversiFields={
                mensoleTamponiCampateImpalcatoTableTraversiTableWatch || []
              }
              selected={selectedTraversi}
              setSelected={setSelectedTraversi}
              traversiTable={`mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traversiTable`}
              selectedIdx={selectedIdx}
            />
          )}
          <DrawerMedia
            open={open}
            setOpen={setOpen}
            title={'Traversi'}
            infoPanel="Per un'ottimizzazione nel report, si consiglia di eseguire foto in orizzontale in rapporto 4:3."
            dataType="video/*,image/*"
            uploadType={UploadMedia.media}
            type={FieldType.images}
            formName={`mensoleTamponiCampateImpalcatoTable[${selectedIdx}].traversiTable[${drawerMediaIndex}].media`}
            mediaGroup={[MediaGroup.Struttura]}
          />
          <GridWrap container spacing={2} mt={2}>
            <GridWrap item xs={12}>
              <Table
                data={
                  mensoleTamponiCampateImpalcatoTableTraversiTableWatch || []
                }
                config={dataConfigTraversi}
                hasCheckbox={!inspectionDisabled && !isViewingInspection}
                rowActions={
                  !inspectionDisabled && !isViewingInspection
                    ? [
                        {
                          onClick: item => {
                            editRowsTraversi(item);
                            setSelectedTraversi([item]);
                          },
                          icon: <EditIcon />,
                        },
                      ]
                    : []
                }
                mediaActions={[
                  {
                    onClick: item => {
                      setDrawerMediaIndex(
                        mensoleTamponiCampateImpalcatoTableTraversiTableWatch.findIndex(
                          el => el.id === item.id
                        )
                      );
                      setOpen(true);
                    },
                    icon: <MediaIcon />,
                  },
                ]}
                selected={selectedTraversi}
                onSelectAllClick={handleSelectAllClickTraversi}
                setSelected={setSelectedTraversi}
              />
            </GridWrap>
          </GridWrap>
        </>
      )}
    </>
  );
};
TraversiSection.propTypes = {
  selectedIdx: PropTypes.number,
};
export default TraversiSection;
